import {analytics} from '@/app/js/analytics'
import {localisation} from '@/app/js/localisation'
import {show, hide} from '@/app/js/loading-overlay'

window.analytics = analytics
window.localisation = localisation
window.loadingOverlay = {
  show,
  hide,
}
